import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

export const togglePins = createAsyncThunk(
  "pins/togglePins",
  async ({ id, token,section }, { rejectWithValue }) => {

    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/${section}/pin/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status) {
        return response.data;
      } else {
        return rejectWithValue("Failed to toggle key status");
      }
    } catch (error) {

      return rejectWithValue(
        error.response?.data.response || "Error toggling key status"
      );
    }
  }
);


const pinSlice = createSlice({
    name: 'pins',
    initialState: {
        
        loading: false,
        error: null,
    },
    reducers: {
        
    },
    extraReducers: (builder) => {
        builder
            .addCase(togglePins.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(togglePins.fulfilled, (state, action) => {
                state.loading = false;
                toast.success(action.payload.response);
                state.items = action.payload;
            })
            .addCase(togglePins.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                toast.error(action.payload);
            });
    },
});

export default pinSlice.reducer;